import { DivisaoEmpresa, EmpresaMRV } from '../_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class EmpresaMRVService {

    constructor(private http: HttpClient,
        private alertService: AlertService) { }

        ObterEmpresaMrv(cnpj: string): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/EmpresaMRV/${cnpj}`;
        return this.http.get<EmpresaMRV>(apiURL);
    }

    obterEmpresaFiscal(cnpj: string): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/EmpresaMRV/fiscal/${cnpj}`;
        return this.http.get<EmpresaMRV>(apiURL);
    }

    ObterCentroLogistico(codigoEmpresa: string, codigoFilial: string): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/EmpresaMRV/centrologistico/${codigoEmpresa}/${codigoFilial}`;
        return this.http.get<EmpresaMRV>(apiURL);
    }

    ObterDivisoesEmpresaMrv(codEmp: string, codFil: string): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/empresamrv/divisoes?codigoEmpresa=${codEmp}&codFil=${codFil}` ;
        return this.http.get<DivisaoEmpresa[]>(apiURL);
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error); // log to console instead
            console.log(`${operation} failed: ${error.message}`);

            this.alertService.error(`Ocorreu um problema ao verificar aempresa MRV. Detalhes: \n ${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

}
